import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { Image } from "react-bootstrap"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { browserHistory, Link } from "react-router"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import OrganizationTable from "./OrganizationTable"
import apiServerApi from "../../redux/sagas/apiServerApi"
import ImpersonationModalForm from "./ImpersonationModalForm"
import { BooleanStatuses, sortDate } from "../../lib/utils"
import ClearFiltersButton from "../fragments/ClearFiltersButton"

class OrganizationList extends Component {

  state = {
    impersonate: false,
    organization: null,
  }

  componentDidMount() {
    this.props.loadOrganizations()
  }

  impersonateClicked = organization => this.setState({
    organization,
    impersonate: true
  })

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.email.cleanFiltered()
    this.refs.collaterals.cleanFiltered()
    this.refs.openedOnFormatted.cleanFiltered()
    this.refs.active.cleanFiltered()
  }

  render() {
    const { organizations, loadOrganizations } = this.props,
    { organization, impersonate } = this.state

    return (
      <div>

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <OrganizationTable
          items={ organizations }
          addNewLabel="New Organization"
          addNewHandler={() => browserHistory.push("/organizations/create")}
          loadOrganizations={ loadOrganizations }>

          <TableHeaderColumn
            dataField="id"
            dataAlign="center"
            tdStyle={{verticalAlign: 'middle'}}
            dataFormat={ (_, row) => {
              const src = row.iconId ? apiServerApi.organizationIconURL(row.id) : require('../../files/company-logo.png')
              return <Image alt={row.name} src={src} rounded width={48} />
            }}
            width="90px"
          />

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataAlign="left"
            dataSort={true}
            tdStyle={{ verticalAlign: 'middle' }}
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName="min-w-120"
            dataFormat={(name, row) =>
              <Link to={`/organizations/${row.id}/detail`} title='Show details'>{ name }</Link>}
            >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='email'
            dataField="email"
            dataSort={true}
            tdStyle={{ verticalAlign: 'middle' }}
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName="min-w-120"
          >
            Email
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='collaterals'
            dataField="collaterals"
            dataSort={true}
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={val => <span className="font-size-13">{ val }</span>}
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName="min-w-120"
          >
            Loan Collaterals
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='openedOnFormatted'
            dataField="openedOnFormatted"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.openedOn, b.openedOn, order)}
            dataAlign="center"
            tdStyle={{ verticalAlign: 'middle' }}
            filter={{ type: "DateFilter", delay: 1000 }}
            columnClassName="min-w-120"
          >
            Opened On
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='active'
            dataField="active"
            dataAlign="center"
            dataSort={true}
            width="90px"
            tdStyle={{ verticalAlign: 'middle' }}
            filter={{ type: "SelectFilter", options: BooleanStatuses }}
            dataFormat={active =>
              <FontAwesome title={ active ? 'Active' : 'Inactive' } style={{ color: active ? 'green' : '#a66' }} 
                name={ active ? 'check' : 'close' } size="lg"/>
            }>
            Active
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="id"
            dataAlign="center"
            isKey={true}
            width="110px"
            tdStyle={{verticalAlign: 'middle'}}
            dataFormat={(_, x) =>
              <span className="flex-detail">
                <Link to={`/organizations/${x.id}/detail`} className='p-5'>
                  <FontAwesome name="eye" size="lg" title='View' />
                </Link>

                <Link to={`/organizations/${x.id}/update`} className='p-5'>
                  <FontAwesome name="pencil" size="lg" title='Update' />
                </Link>

                <span className="cursor-pointer red p-5" onClick={() => this.impersonateClicked(x)}>
                  <FontAwesome name="user-md" size="lg" title='Impersonate this organization' />
                </span>
              </span>
            }
          />
        </OrganizationTable>

        { !!organization &&
         <ImpersonationModalForm
            organization={ organization }
            show={ impersonate }
            close={() => this.setState({ impersonate: false })}
          />}
      </div>
    )
  }
}

OrganizationList.propTypes = {
  organizations: PropTypes.array.isRequired,
  loadOrganizations: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const organizations = DckSelectors.selectAllItems(state, ItemTypes.Organization)
  return { organizations }
},

mapDispatchToProps = dispatch => ({
  loadOrganizations: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Organization)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationList)



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationList.js